import React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';

import { set_token } from './../../actions';
import { getActiveLanguage } from 'react-localize-redux';
import { customerJourneyHotel } from './../../actions';

import browserLanguage from './../../stores/browserLanguage';

import './tokensetter.scss';

export const tokenSetter = (Component) => {

  class TokenSetter extends React.Component {

    constructor(props) {
      super(props);
    }

    /* Methods */

    setTemplateClass(templateClass) {
      /* Change html class - THIS IS AN ANTI PATTER!!! BUT FAST TO DO :-) */
      var html = document.documentElement;
      html.className = templateClass;
    }

    /* Life Cycle */

    componentWillMount() {
      if(!this.props.match.params.token && !this.props.token) {
        this.setTemplateClass('BWCore');
        return;
      }
      
      /* Set Token */
      if(this.props.match.params.token) {
        this.props.actions.setToken(this.props.match.params.token, this.props.match.params.context, this.props.currentLanguage); // this will trigger hotel and reservation api call too
      }
      else {
        this.setTemplateClass(this.props.template);
      }
    }

    componentWillReceiveProps(nextProps) {
      if(!this.props.match.params.token && !this.props.token) {
        this.setTemplateClass('BWCore');
        return;
      }

      /* Set Token */
      if(this.props.match.params.token != nextProps.match.params.token) {
        this.props.actions.setToken(nextProps.match.params.token, nextProps.match.params.context, nextProps.currentLanguage); // this will trigger hotel and reservation api call too
      }
      this.setTemplateClass(nextProps.template);
    }

    render() {
      return (
        <div className="tokensetter-component">
          {/*this.props.token && this.props.template ? <Component {...this.props} /> : null*/}
          <Component {...this.props} />
        </div>
      );
    }

    }
    
    TokenSetter.displayName = 'SharedTokenSetter';
    TokenSetter.propTypes = {};
    TokenSetter.defaultProps = {};

    return TokenSetter;

};

const connectedTokenSetter = (Component) => {

  const mapStateToProps = (state) => {
    return { 
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      template: state.hotel.apiData.template 
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      actions: {
        setToken: bindActionCreators(set_token, dispatch),
        customerJourneyHotel: bindActionCreators(customerJourneyHotel, dispatch)
      }
    };
  };
  
  return compose(connect(mapStateToProps, mapDispatchToProps), tokenSetter)(Component);

};

export default connectedTokenSetter;



// WEBPACK FOOTER //
// ./components/shared/TokenSetter.js